import { render } from "./ApprovalStatePill.vue?vue&type=template&id=84b097fc&scoped=true"
import script from "./ApprovalStatePill.vue?vue&type=script&lang=js"
export * from "./ApprovalStatePill.vue?vue&type=script&lang=js"

import "./ApprovalStatePill.vue?vue&type=style&index=0&id=84b097fc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84b097fc"]])

export default __exports__